import Vue from 'vue';

export default {
    PRESEDITOR_RESET: function(state) {
    	if(this.getters.devmode) console.debug('M|PRESEDITOR_RESET', data);
        state.presentation = false;
		state.charts = false;
    },



	// ------------------------ ADDCHART ------------------------
    START_ADDCHART: function(state, id) {
    	if(id === 0) id = true;
    	if(this.getters.devmode) console.debug('M|START_ADDCHART', id);
    	state.addchart = id;
    },
    END_ADDCHART: function(state) {
    	if(this.getters.devmode) console.debug('M|END_ADDCHART');
    	state.addchart = false;
    },


    // ------------------------ CHARTSTEMPALTES ------------------------
    SET_CHARTTEMPLATES: function(state, templates) {
    	if(this.getters.devmode) console.debug('M|SET_CHARTTEMPLATES', templates);
    	if(!state.chartemplates) state.chartemplates = {};
    	state.chartemplates = Object.assign({}, state.chartemplates, templates)
    },
    UNSET_CHARTTEMPLATES: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_CHARTTEMPLATES');
        state.chartemplates = false;
    },

    ADD_CHARTTEMPLATES: function(state, templates) {
    	if(this.getters.devmode) console.debug('M|ADD_CHARTTEMPLATES', templates);
    	Object.keys(templates).forEach(name => {
    		this.commit('ADD_CHARTTEMPLATE', {
    			name: name,
    			template: templates[name]
    		});
    	});
    },
    REMOVE_CHARTTEMPLATES: function(state, templatenames) {
    	if(this.getters.devmode) console.debug('M|REMOVE_CHARTTEMPLATES', templatenames);
        templatenames.forEach(name => {
    		this.commit('REMOVE_CHARTTEMPLATE', name);
    	});
    },

    ADD_CHARTTEMPLATE: function(state, charttemplate) {
    	if(this.getters.devmode) console.debug('M|ADD_CHARTTEMPLATE', charttemplate);
    	if(!state.chartemplates) state.chartemplates = {};
    	Vue.set(state.chartemplates, charttemplate.name, charttemplate.template);
    },

    REMOVE_CHARTTEMPLATE: function(state, name) {
    	if(this.getters.devmode) console.debug('M|REMOVE_CHARTTEMPLATE', name);
    	if(!state.chartemplates) state.chartemplates = {};
    	Vue.delete(state.chartemplates, name);
    },

    START_LOADING_CHARTTEMPLATES: function(state) {
    	if(this.getters.devmode) console.debug('M|START_LOADING_CHARTTEMPLATES');
        state.chartemplates_loading = true;
    },
	STOP_LOADING_CHARTTEMPLATES: function(state) {
		if(this.getters.devmode) console.debug('M|STOP_LOADING_CHARTTEMPLATES');
        state.chartemplates_loading = false;
    },




    // ------------------------ CHARTS ------------------------
    SET_CHARTS: function(state, data) {
    	if(this.getters.devmode) console.debug('M|SET_CHARTS', data);
        state.charts = data;
    },
    UNSET_CHARTS: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_CHARTS');
        state.charts = {};
    },

    TOGGLE_CHART_VISIBILITY(state, id){
    	if(this.getters.devmode) console.debug('M|TOGGLE_CHART_VISIBILITY', id);
    	let chart = this.getters.getChartById(id);
		if(chart) chart.visible = !chart.visible;
		state.charts = state.charts; // trigger update?
    },

    TOGGLE_CHART_TRASHED(state, id){
    	if(this.getters.devmode) console.debug('M|TOGGLE_CHART_TRASHED', id);
    	let chart = this.getters.getChartById(id);
		if(chart) chart.trashed = !chart.trashed;
		state.charts = state.charts; // trigger update?
    },

    DELETE_CHART(state, chartid){
    	if(this.getters.devmode) console.debug('M|DELETE_CHART', chartid);

    	let chart = this.getters.getChartById(chartid, true);
    	if(chart.parent && chart._index && chart.parent[chart._index]) {
    		if(this.getters.devmode) console.debug('M|DELETE_CHART M 2', chart.id, chart.parent, chart._index);
    		Vue.delete(chart.parent, chart._index);

    	} else if (state.charts[chartid]) {
    		if(this.getters.devmode) console.debug('M|DELETE_CHART M 3', chart.id, chartid);
    		Vue.delete(state.charts, chartid);

    	} else if(chart.parent && chart.parent.charts && chart.parent.charts[chart.id]) {
    		if(this.getters.devmode) console.debug('M|DELETE_CHART M 1', chart.id, chartid);
    		Vue.delete(chart.parent.charts, chartid);

    	} else if (chart._index && state.charts[chart._index]) {
    		if(this.getters.devmode) console.debug('M|DELETE_CHART M 4', chart.id, chartid, chart._index);
    		Vue.delete(state.charts, chart._index);
    	}

    	state.charts = state.charts;
    },

	UPDATE_CHART(state, payload){
		if(this.getters.devmode) console.debug('M|UPDATE_CHART', payload);
		const id = payload.id;

		let oldPosition = false,
			newPosition = false,
			parent		= false;

		let chart = this.getters.getChartById(id, true);
		Object.keys(payload)
			.forEach(key => {
				if(key == 'id') return;
				switch(key){
					case 'position':
						oldPosition = chart[key];
						newPosition = payload[key];
						parent = (chart.parent ? chart.parent.charts : this.getters.charts);
						delete chart.parent;
						break;

					default:
						Vue.set(chart, key, payload[key]);
						break;
				}
			});

		chart.changed = true;

		// reorder
		if(
			oldPosition >= 0 &&
			newPosition >= 0 &&
			parent){
			let indixer = 0;
			Object.keys(parent)
			.filter(key => {
				return parent[key].id != id;
			}).sort((a,b) => {
				if(parent[a].position == parent[b].position) return 0;
				return parent[a].position < parent[b].position ? -1 : 1;
			}).forEach((key, index) => {
				let item = parent[key];
				if(index == newPosition) indixer += 1;

				item.position = index + indixer;
			});

			chart.position = newPosition;
		}
		Vue.set(state.presentation, 'changed', true);
		state.charts = state.charts; // trigger update?

	},



	UPDATE_FIELD(state, payload){
		if(this.getters.devmode) console.debug('M|UPDATE_FIELD', payload);
		const id = payload.id,
			  fieldname = payload.fieldname;

		this.dispatch('socket/SEND_PACKAGE', {
			name: 'UPDATE_FIELD',
			payload: payload,
			time: new Date().getTime()
		});

		let chart = this.getters.getChartById(id),
			field = chart.fields[fieldname];

		Object.keys(payload).forEach(key => {
			if(key == 'id' || key == 'fieldname') return;

			Vue.set(field, key, payload[key]);

			Vue.set(field, 'changed', true);
		});

		chart.changed = true;

		state.charts = state.charts; // trigger update?
	},

    // ------------------------ CHART ------------------------
    SET_PRESENTATION: function(state, data) {
    	if(this.getters.devmode) console.debug('M|SET_PRESENTATION', data);
        state.presentation = data;
    },
    UNSET_PRESENTATION: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_PRESENTATION');
        state.presentation = {};
    },
    SET_PRESENTATIONID: function(state, cid) {
    	if(this.getters.devmode) console.debug('M|SET_PRESENTATIONID', cid);
        state.active_presentation = cid;
    },
    RESET_PRESENTATIONID: function(state) {
    	if(this.getters.devmode) console.debug('M|RESET_PRESENTATIONID');
      	state.active_presentation = 0;
    },
    SET_ACTIVE_FIELD: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_ACTIVE_FIELD', payload);
        state.active_field = payload;
    },
    RESET_ACTIVE_FIELD: function(state) {
    	if(this.getters.devmode) console.debug('M|RESET_ACTIVE_FIELD');
      	state.active_field = false;
    },

	SET_ADDABLECHARTS: function(state, data){
		if(this.getters.devmode) console.debug('M|SET_ADDABLECHARTS');
		state.editor.addablecharts = data;
	},
	UNSET_ADDABLECHARTS: function(state){
		if(this.getters.devmode) console.debug('M|UNSET_ADDABLECHARTS');
		state.editor.addablecharts = {};
	},

	ADD_CHARTCOMPONENTS: function(state, name){
		if(this.getters.devmode) console.debug('M|ADD_CHARTCOMPONENTS', name);
		state.editor.chartcomponents.push(name)
	},

	REMOVE_CHARTCOMPONENTS: function(state, name){
		if(this.getters.devmode) console.debug('M|REMOVE_CHARTCOMPONENTS');
		const index = state.editor.chartcomponents.find(name);
		if(index){
			delete state.editor.chartcomponents[index];
		}
	},

	INCREASE_NEWCHARTCOUNTER: function(state) {
    	if(this.getters.devmode) console.debug('M|INCREASE_NEWCHARTCOUNTER');
        state.newchartcounter -= 1;
    },
}



// WEBPACK FOOTER //
// ./src/store/preseditor/mutations.js